export const images = {
  noData: require('./no_results.png'),
  somethingWentWrong: require('./sth_went_wrong.png'),
};
